import React from "react";
import ChatHeader from "./ChatHeader";
import ChatSidebar from "./ChatSidebar";
import Disclaimer from "./Disclaimer";
import LoaderPage from "./Loader/LoaderPage";
import PageNotFound from "../../pages/common/PageNotFound";
import { format } from "date-fns";

interface MainPageComponentsProps {
  title: string;
  content: string;
  loading: boolean;
  updated_at: string;
}

const MainPageComponents: React.FC<MainPageComponentsProps> = ({ title, content, loading, updated_at = "", }) => {
  const hasContent = content?.trim().length > 0;
  const formattedDate = updated_at ? format(new Date(updated_at), "PP") : "";


  if (loading) {
    return (
      <div>
        <ChatHeader />
        <div className="chat-row-container flex-columns columns-full">
          <ChatSidebar />
          <main className="max-w-4xl mx-auto p-6 h-100dvh">
            <div className="not-found-container">
              <LoaderPage />
            </div>
          </main>
        </div>
        <Disclaimer />
      </div>
    );
  }

  if (!hasContent) {
    return <PageNotFound />;
  }

  return (
    <div>
      <ChatHeader />
      <div className="chat-row-container flex-columns columns-full">
        <ChatSidebar />
        <main className="chat-row-container flex-columns columns-full">
          <div className="max-w-4xl mx-auto p-6 right-content-wrapper h-100dvh">
            <div className="chat-title">
              <h1 style={{ textTransform: "capitalize" }}>{title}</h1>
            </div>
            <div className="cms-wrapper">
              <div className="cms-wrapper-inner h-cal">
                <div dangerouslySetInnerHTML={{ __html: content }} />

                {formattedDate && (
                  <div className="updated-at">
                    <small>Date of Last Review: {formattedDate}</small>
                  </div>
                )}

              </div>
            </div>
          </div>
        </main>
      </div>
      <Disclaimer />
    </div>
  );
};

export default MainPageComponents;
